import { createContext, useContext } from 'react'
import type { ChatMessage, ChoiceOption, TriageResolvedAction } from '../../shared/types/chat'

export interface ChatActions {
  onApprove: (messageId: string, connectionId?: string, editedBody?: string) => void
  onDeny: (messageId: string) => void
  onChoiceSelect: (messageId: string, option: ChoiceOption) => void
  onMultiChoiceToggle: (messageId: string, optionId: string) => void
  onMultiChoiceSubmit: (messageId: string) => void
  onChecklistToggle: (messageId: string, itemId: string) => void
  onChecklistDone: (messageId: string) => void
  onComparisonSelect: (messageId: string, optionId: string, optionName: string) => void
  onInfoAction: (messageId: string, actionId: string, actionLabel: string, linkedNoteId?: string) => void
  onUpdateMessage: (messageId: string, updater: (msg: ChatMessage) => ChatMessage) => void
  onSendMessage: (content: string) => void
  onSaveToNotebook: (messageId: string) => void
  onViewInNotebook: (noteId: string) => void
  onTriageAction: (messageId: string, signalId: string, action: TriageResolvedAction) => void
  onNavigate: (screen: string) => void
  onLongPress: (messageId: string) => void
  /** Dismiss a briefing item locally + persist via /briefing/dismiss. */
  onDismissBriefingItem: (messageId: string, args: { description: string; itemKey?: string; sectionIndex: number; itemIndex: number }) => void
  /** Resolve a follow-up referenced from a briefing item. */
  onResolveFollowup: (messageId: string, args: { followupId: string; sectionIndex: number; itemIndex: number }) => void
  /** Open an email in the detail sheet — used by tappable briefing inbox items. */
  onOpenEmail: (emailId: string) => void
}

const ChatContext = createContext<ChatActions | null>(null)
export const ChatProvider = ChatContext.Provider

// eslint-disable-next-line react-refresh/only-export-components
export function useChatActions(): ChatActions {
  const ctx = useContext(ChatContext)
  if (!ctx) throw new Error('useChatActions must be used within ChatProvider')
  return ctx
}
